import _default from './Container';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Container/index.js
// module id = 1507
// module chunks = 1